import { useAuthState } from '@/app/providers/auth'
import { getTenantFromWindow } from '@/helpers/tenants'

import { useParams } from 'next/navigation'

import { SPLITS, useFeatureFlag } from './useFeatureFlag'

/** Enforced wherever an item note is entered (menu item modal or basket
    popover), so the limit is consistent across both. */
export const ITEM_NOTE_MAX_LENGTH = 300

/** Single source of truth for the removeItemNotes targeting attributes, so the
    menu item modal and the basket always agree on whether notes are enabled
    for a given tenant/account — evaluating this separately in two places is
    what let them drift out of sync before. */
export const useItemNotesRemovedByFlag = (): boolean => {
  const params = useParams()
  const country = params?.lang || ''
  const tenant = typeof window !== 'undefined' ? getTenantFromWindow() : undefined
  const auth = useAuthState()

  return useFeatureFlag(SPLITS.REMOVE_ITEM_NOTES, {
    country: country.toString().split('-')[1].toUpperCase(),
    tenant: tenant?.id || '',
    service: 'GM',
    accountId: auth.type === 'authenticated' ? (auth.user.account?.id ?? '') : '',
  })
}
